module.exports = __webpack_public_path__ + "static/img/wechat_icon.8877a53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wechat_icon.png
// module id = FdfO
// module chunks = 1